import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/pages/Login/store";
import { PageLoader } from "@/components/ui/PageLoader";
import { paths } from "./paths";

type Props = {
  children: React.ReactNode;
};

export const AuthenticatedRoute = ({ children }: Props) => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const isLoading = useAuthStore((state) => state.isLoading);
  if (isLoading) {
    return <PageLoader isLoading={true} />;
  }
  if (!isLoggedIn) {
    return <Navigate to={paths.LOGIN} replace />;
  }
  return <>{children}</>;
};
